
export class IDPReport {
  // Note: Using only optional constructor properties without backing store disables typescript's type checking for the type
  constructor(

     AccountName: string,
     AccountOwnerName: string,
     AccountTaxId: string,
     AccountActive: string,
     AccountParentDistributorCode: string,
     AccountStatus: string,
     AccountPromotingOwnerName: string,
     AccountUsOrCanada: string,
     AccountPoCompany: string,
     Active: string,
     City: string,
     DistributorCode: string,
     HubEmail: string,
     HubName: string,
     JdeDistroNo: string,
     LastKnownAddress: string,
     State: string,
    ZipCode: string,
    AccountNationalConsultantName: string,
    AccountNationalConsultant: string,
    AccountRegionalConsultantName: string,
    AccountRegionalConsultantCompanyName: string,
    Location_Type : string
  ) {

    this.AccountName = AccountName;
    this.AccountOwnerName = AccountOwnerName;
    this.AccountTaxId = AccountTaxId;
    this.AccountActive = AccountActive;
    this.AccountParentDistributorCode = AccountParentDistributorCode;
    this.AccountStatus = AccountStatus;
    this.AccountPromotingOwnerName = AccountPromotingOwnerName;
    this.AccountUsOrCanada = AccountUsOrCanada;
    this.AccountPoCompany = AccountPoCompany;
    this.AccountNationalConsultantName = AccountNationalConsultantName;
    this.AccountNationalConsultant = AccountNationalConsultant;
    this.AccountRegionalConsultantName = AccountRegionalConsultantName;
    this.AccountRegionalConsultantCompanyName = AccountRegionalConsultantCompanyName;
    this.Active = Active;
    this.City = City;
    this.DistributorCode = DistributorCode;
    this.HubEmail = HubEmail;
    this.HubName = HubName;
    this.JdeDistroNo = JdeDistroNo;
    this.LastKnownAddress = LastKnownAddress;
    this.State = State;
    this.ZipCode = ZipCode;
    this.Location_Type = Location_Type;
  }

  


  public AccountName: string;
  public AccountOwnerName: string;
  public AccountTaxId: string;
  public AccountActive: string;
  public AccountParentDistributorCode: string;
  public AccountStatus: string;
  public AccountPromotingOwnerName: string;
  public AccountUsOrCanada: string;
  public AccountPoCompany: string;
  public Active: string;
  public City: string;
  public DistributorCode: string;
  public HubEmail: string;
  public HubName: string;
  public JdeDistroNo: string;
  public LastKnownAddress: string;
  public State: string;
  public ZipCode: string;
  public AccountNationalConsultantName: string;
  public AccountNationalConsultant: string;
  public AccountRegionalConsultantName: string;
  public AccountRegionalConsultantCompanyName: string;
  public Location_Type: string;
}


export class CPReport {
  // Note: Using only optional constructor properties without backing store disables typescript's type checking for the type
  constructor(

    Id: string,
    Name: string,
    CampaignName: string,
    ClientName: string,
    ConsultantName: string,
    StartDate: string,
    EndDate: string,
    CampaignConsultant: string,
    AccountName: string,
    AccountTaxID: string,
    AccountOwnerName: string,
    AccountParentDistributorCode: string,
    AccountActive: string,
    AccountHubName: string,
    AccountStatus: string,
    UserName: string,
    
  ) {
    this.Id = Id;
    this.Name = Name;
    this.AccountActive = AccountActive
    this.AccountHubName = AccountHubName;
    this.AccountParentDistributorCode = AccountParentDistributorCode;
    this.AccountName = AccountName;
    this.AccountOwnerName = AccountOwnerName;
    this.AccountStatus = AccountStatus;
    this.AccountTaxID = AccountTaxID;
    this.CampaignConsultant = CampaignConsultant;
    this.CampaignName = CampaignName;
    this.ClientName = ClientName;
    this.ConsultantName = ConsultantName;
    this.EndDate = EndDate;
    this.StartDate = StartDate;
    this.UserName = UserName;
    
  }


  public Id: string;
  public Name: string;
  public CampaignName: string;
  public ClientName: string;
  public ConsultantName: string;
  public StartDate: string;
  public EndDate: string;
  public CampaignConsultant: string;
  public AccountName: string;
  public AccountTaxID: string;
  public AccountOwnerName: string;
  public AccountParentDistributorCode: string;
  public AccountActive: string;
  public AccountHubName: string;
  public AccountStatus: string;
  public UserName: string;

   

}


export class CMReport {
  // Note: Using only optional constructor properties without backing store disables typescript's type checking for the type
  constructor(

    Id: string,
    Name: string,
    CampaignName: string,
    Channel: string,
    Status: string,
    LegacyCampaignInfo: string,
    SupplementalBackground: string,
    BackgroundCheck: string,
    DrugScreen: string,
    Country: string,
    DueDiligenceRequired : string

  ) {
    this.Id = Id;
    this.Name = Name;    
    this.CampaignName = CampaignName;
    this.Channel = Channel;
    this.Status = Status;
    this.LegacyCampaignInfo = LegacyCampaignInfo;
    this.SupplementalBackground = SupplementalBackground;
    this.BackgroundCheck = BackgroundCheck;
    this.DrugScreen = DrugScreen;
    this.Country = Country;
    this.dueDiligenceRequired = DueDiligenceRequired;

  }


  public Id: string;
  public Name: string;
  public CampaignName: string;
  public Channel: string;
  public Status: string;
  public LegacyCampaignInfo: string;
  public SupplementalBackground: string;
  public BackgroundCheck: string;
  public DrugScreen: string;
  public Country: string;
  public dueDiligenceRequired: string;


}



export class CDReport {
  // Note: Using only optional constructor properties without backing store disables typescript's type checking for the type
  constructor(

    Id: string,
    CaseNumber: string,
    Reason: string,
    CaseOriginator: string,
    Status: string,
    CreatedDate: string,
    AccountName: string,
    AccountOwnerName: string,
    AccountHubName: string,
    NextStep: string

  ) {
    this.Id = Id;
    this.CaseNumber = CaseNumber;
    this.Reason = Reason;
    this.CaseOriginator = CaseOriginator;
    this.Status = Status;
    this.CreatedDate = CreatedDate;
    this.AccountName = AccountName;
    this.AccountOwnerName = AccountOwnerName;
    this.AccountHubName = AccountHubName;
    this.NextStep = NextStep;

  }


  public Id: string;
  public CaseNumber: string;
  public Reason: string;
  public CaseOriginator: string;
  public Status: string;
  public CreatedDate: string;
  public AccountName: string;
  public AccountOwnerName: string ;
  public AccountHubName: string;
  public NextStep: string;
  public caseCounts:CDCountReport[];
   

}

export class CDCountReport {

  constructor(case_count: number, status: string) {
    this.case_count = case_count;
    this.status = status;

  }

  public case_count: number;
  public status: string;
   
   

}

export class ICD {
   
  public US_or_CA: string;  
  public Owner_First_Name: string;
  public Owner_Middle_Name: string;
  public Owner_Last_Name: string;
  public Owner_Preferred_First_Name: string;
  public Owner_Preferred_Last_Name: string;
  public Full_Legal_Company_Name: string;
  public Tax_ID: string;
  public Tax_ID_C: string;  
  public Owner_Email: string;
  public Date_of_Incorporation: string;
  public HUB_Manager_Contact_Name: string;
  public HUB_Manager_Contact_Number:  string;
  public HUB_Manager_Contact_Email: string;
  public HUB_Manager_Contact: string;
  public State_of_Incorporation: string;
  public Provinence_of_Incorporation: string;

  public PromotingOwner: string;
  public PromotingOwnerCompany: string;
  public RegionalConsultant: string;
  public RegionalConsultantCompany: string;
  public NationalConsultant: string;
  public NationalConsultantCompany: string;

  public PromotingOwnerId: string;
  public Selected_camp: string;
  public Preferred_Name_Different_from_Legal_Name__c: string;

  // Feature 10 — secondary owner
  public Has_Secondary_Owner: string;
  public Secondary_Owner_First_Name: string;
  public Secondary_Owner_Middle_Name: string;
  public Secondary_Owner_Last_Name: string;
}


export class ICDStep2 {

  public US_or_CA: string;
  public Full_Legal_Company_Name: string;
  public Tax_ID: string;
  public State_of_Incorporation: string;
  public Provinence_of_Incorporation: string;
  public Date_of_Incorporation: string;

  public ICDInfoReceivedOn: string;
  public HubInfoReceivedOn: string;
  public ICDAckReceivedOn: string;
  public HubInfoReviewedOn: string;

  public Company_Address1: string;
  public Company_Address2: string;
  public Company_City: string;
  public Company_Postal_Code: string;
  public Company_Office_Phone: string;
  public Company_Business_Email: string;
  public Company_Country: string;
  public Company_State: string;
  public Company_Province: string;

  public Owner_First_Name: string;
  public Owner_Last_Name: string;
  public Owner_Name: string;
  public Owner_Middle_Name: string;
  public Owner_Preferred_First_Name: string;
  public Owner_Preferred_Last_Name: string;
  public Owner_Perc: string;
  public Owner_Address1: string;
  public Owner_Address2: string;
  public Owner_City: string;
  public Owner_Country: string;
  public Owner_State: string;
  public Owner_Province: string;
  public Owner_Postal_Code: string;
  public Owner_Office_Phone: string;
  public Owner_Home_Phone: string;
  public Owner_Email: string;
  public SSN_SIN: string;
  public Owner_Consent: string;
  public Owner_Demographics: string;
  
  
  public HUB_Manager_Contact_Name: string;
  public HUB_Manager_Contact_Number: string;
  public HUB_Manager_Contact_Email: string;
  public HUB_Assistance_Email: string;
  public HUB_Manager_Contact: string;
  public AccountID: string;
  public CaseID: string;
  public ContactID: string;

  public Campaigns: string;

  public Legal_Email: string;
  public Mobile_Phone: string;
  public Preferred_Name_Different_from_Legal_Name__c: string;
  public Attachments: fileData[] = [];
}


export class ICDStep3 {

  public US_or_CA: string;
  public Full_Legal_Company_Name: string;
  public Tax_ID: string;
  public State_of_Incorporation: string;
  public Years_in_Business: string;
  public Provinence_of_Incorporation: string;
  public Date_of_Incorporation: string;

  public ICDInfoReceivedOn: string;
  public Company_Address1: string;
  public Company_Address2: string;
  public Company_City: string;
  public Company_Postal_Code: string;
  public Company_Office_Phone: string;
  public Company_Business_Email: string;
  public Company_Country: string;
  public Company_State: string;
  public Company_Province: string;

  public Owner_First_Name: string;
  public Owner_Middle_Name: string;
  public Owner_Last_Name: string;
  public Owner_Name: string;
  public Owner_Preferred_First_Name: string;
  public Owner_Preferred_Last_Name: string;
  public Owner_Perc: string;
  public Owner_Address1: string;
  public Owner_Address2: string;
  public Owner_City: string;
  public Owner_Country: string;
  public Owner_State: string;
  public Owner_Province: string;
  public Owner_Postal_Code: string;
  public Owner_Office_Phone: string;
  public Owner_Home_Phone: string;
  public Owner_Email: string;
  public SSN_SIN: string;


  public HUB_Manager_Contact_Name: string;
  public HUB_Manager_Contact_Number: string;
  public HUB_Manager_Contact_Email: string;
  public HUB_Manager_Contact: string;
  public HUB_Assistance_Email: string;
  public AccountID: string;
  public CaseID: string;
  public ContactID: string;

  public ICD_Using_HerbJoy_for_Insurance__c: string;
  public PromotingOwner: string;
  public PromotingOwnerCompany: string;
  public RegionalConsultant: string;
  public RegionalConsultantCompany: string;
  public NationalConsultant: string;
  public NationalConsultantCompany: string;

  public LoadingDock: string;
  public ForkLift: string;
  public StraightTruckRequired: string;
  public AppointmentRequired: string;
  public LiftGateRequired: string;
  public DeliveryContactName: string;
  public AlternateContactName: string;
  public HoursofOperation: string;
  public BestDeliveryTime: string;
  public SpecialDeliveryRequirements: string;

  public CompanyWebsite: string;

  public Campaigns: string;
  public Retailers: string;


  public Campaigns_R: string;
  public Retailers_R: string;

  public Attach_US_Articles_of_Incorporation: string;
  public Attach_US_W_9: string;
  public Attach_US_Node_Form: string;
  public Attach_US_SS4_EIN: string;
  public Attach_US_Void_Check_Bank_Account: string;
  public Attach_US_Additional_Insurance: string;
  public Attach_US_Form_8821: string;
  public Attach_US_Homeowner_Insurance: string;
  public Attach_US_ADP_Payroll: string;
  public Attach_US_Certificate_of_Insurance: string;
  public Attach_US_Payroll_Setup: string;

  public Attach_Canada_Articles_of_Incorporation: string;
  public Attach_Canada_CRA_Consent: string;
  public Attach_Canada_Bank_Account_statement: string;
  public Attach_Canada_Worker_Compensation_Coverage: string;
  public Attach_Canada_Insurance_Application: string;
  public Attach_Canada_Additional_Insurance_Questionnaire: string;
  public Attach_Canada_Homeowner_Insurance: string;
  public Attach_Canada_ADP_Payroll: string;
  public Attach_Canada_Out_of_Province_Qualification: string;
  public Attach_Canada_Waddell_Privacy: string;
  public Attach_Canada_Certificate_of_Insurance: string;
  public DBA_Data: any[] = [];
  public Attachments: fileData[] = [];
  public TestCampaignNotListed: string;
  public TestCampaignNotListed_R: string;
  public ICDAckReceivedOn: string;
  public HubInfoReceivedOn: string;
  
  public IsSubmitted: boolean;

  public State_UI_ID: string;
  public First_Date_New_Address: string;
  public New_Address: string;
  public Sales_tax_perc: string;
  public New_Location_out_state: string;
  public Is_storage_location: string;
  public Main_or_Satellite: string;
  public Is_primary_location: string;
  public Distributor_Code: string;

  public Owner_Office_Phone_N: string;
  public Company_Office_Phone_N: string;
  public Owner_Email_N: string;
  public Sales_tax_perc_N: string;
  public isNew_DBA_Name: string;
  public New_DBA_Name: string;
  public isRemove_DBA_Name: string;
  public isInsuranceRequired: boolean;
  public Remove_DBA_Name: string;
  public IsPreferredDBA: string;       
  public PreferredDBAName: string;     


  public Company_Address1_N: string;
  public Company_Address2_N: string;
  public Company_City_N: string;
  public Company_Country_N: string;
  public Company_State_N: string;
  public Company_Province_N: string;
  public Company_Postal_Code_N: string;
   
  public Reason_for_Closure: string;
  public Last_Date_Insurance: string;
  public Last_Date_WC_Coverage: string;
  public Last_Date_payroll: string;
  public Last_Date_Service: string;

  public Keep_Payroll_Active: string;
  public Keep_Workers_Active: string;
  public Keep_Insurance_Active: string;

 
  public Effective_Date: string;
  public ICD_retrain: string;
  public Comments: string;

  public Hub_New: string;
  public Preferred_Name_Different_from_Legal_Name__c: string;


  public Male_Emp: string;
  public FeMale_Emp: string;
  public Disability_Form: string;

  public TBD_Comments: string;

  public Payroll_Provider__c: string;
  public Payroll_Provider_other__c: string;
  
}

export class MasterConfig {

  public id: number;
  public name: string;
  public value: string ;
  public type: string ;
  public description: string ;


}

export class EmailLog {
  public id!: number;
  public emailFrom!: string;
  public replyTo!: string;
  public mailTo!: string;
  public mailCC!: string;
  public mailBCC!: string;
  public mailSubject!: string;
  public mailBody!: string;
  public status!: string;
  public remarks!: string;
  public deliveredDateTime?: Date;
  public createdDateTime!: Date;
  public isAttachment?: boolean;
  public attachementID!: string;
  public attachementName!: string;
  public attachementURL!: string;
  public accountID!: string;
  public contactID!: string;
  public caseID!: string;
  public isResent?: boolean;
  public isReminder?: boolean;
}


export class fileData
{
  attachment_FileName: string;
  attachment_Base64: string;
  attachment_Type: string
  // Staged-upload tracking (upload-on-select). Optional so existing flows are unaffected.
  FileId?: string;
  Url?: string;
  status?: 'uploading' | 'uploaded' | 'error';
  // The UniqueID this file was staged under; sent back at submit so confirm reuses it.
  StagingUniqueId?: string;
}
export class ResponseAPI {
  public status: string

  public description: string

  public  isSuccess: boolean

  public data : any


  public isValidationError: boolean
}

export class ErrorList {
  
  public error: Error;
}

export class Error {
  public errorCode: string;
  public message: string;
}

